import { styled, Chip } from "@mui/material";

export const StyledChip = styled(Chip)(({ theme }) => ({
    borderRadius: '0.25rem',
        fontSize: '0.75rem',
        padding: '0.25rem 0.5rem',
        '& .MuiChip-label': {
            padding: '0',
        },
        height: '1.75rem',
        minWidth: 'fit-content',
        width: '4rem'
}));

export default StyledChip;
